import React from "react";
import TopTitleBar from "../../../pages/DashBoard/ExternalDash/TopTitleBar";
import styles from './BreadCrumb.module.css'
import { Icon } from 'react-icons-kit';
import { arrow_right } from 'react-icons-kit/ikons/arrow_right';
import { ic_check } from 'react-icons-kit/md/ic_check'
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Breadcrumb = ({ pos, title, category }) => {
    const User=useSelector(state=>state.User)
    // const tabs =title==="Request Verification"? [{
    //     name: "Select Verification Form",
    //     link: '/dashboard/credentials',
    //     pos: 1,
    // }, {
    //     name: 'Recipients Details',
    //     link: '/dashboard/credentials',
    //     pos: 2
    // }
    // ]:[{
    //     name: "Select form type",
    //     link: '/dashboard/credentials',
    //     pos: 1,
    // }, {
    //     name: 'Assign Tags',
    //     link: '/dashboard/credentials',
    //     pos: 2
    // },

    //     {
    //         name: 'Customize Template',
    //         link: '/dashboard/credentials',
    //         pos: 3
    //     }
    // ]


    const tabs = {
        'verification': [{
            name: "Select Verification Form",
            link: '/dashboard//forms/selectForms',
            pos: 1,
        }, {
            name: 'Recipients Details',
            link: '/dashboard/forms/selectType',
            pos: 2
        }
        ],
        'some': [{
            name: "Select form type",
            link: '/dashboard/credentials',
            pos: 1,
        }, {
            name: 'Assign Tags',
            link: '/dashboard/credentials',
            pos: 2
        },

        {
            name: 'Customize Template',
            link: '/dashboard/credentials',
            pos: 3
        }
        ],
        'issuer': [{
            name: "Choose Document",
            link: User.user_type=="Super Admin"?"/company/2/2/credentials":':/dashboard/credentials',
            pos: 1,
        }, {
            name: 'Single/Bulk',
            link:  User.user_type=="Super Admin"?"/company/2/2/credentials":'/dashboard/credentials',
            pos: 2
        },

        {
            name: 'Add Recipient Details',
            link: User.user_type=="Super Admin"?"/company/2/2/credentials":'/dashboard/credentials',
            pos: 3
        },
        {
            name: "Publish Document",
            link:  User.user_type=="Super Admin"?"/company/2/2/credentials":"/dashboard/credentials",
            pos: 4
        }
        ],
        'template': [{
            name: "Choose Document Type",
            link: '/dashboard/credentials',
            pos: 1,
        }, {
            name: 'Assign Tags',
            link: '/dashboard/credentials',
            pos: 2
        },

        {
            name: "Design Template",
            link: '/dashboard/credentials',
            pos: 3
        },
        {
            name:"Publish Document",
            link:"/dashboard/credentials",
            pos:4
        }
        ],
        "verifier":[
            {
                name: "Select Verification Form",
                link: '/dashboard/credentials',
                pos: 1,
            }, {
                name: 'Assign fields or documents',
                link: '/dashboard/credentials',
                pos: 2
            },
            {
                name:"Publish Document",
                link:"/dashboard/credentials",
                pos:3   
            }
        ]

    }

    return (
        <div style={{backgroundColor:"white", padding:"10px, 15px", width:"100%"}}>
            <h4 className="secondaryButton1">
                {title}
            </h4>
            <TopTitleBar isChild>
                {tabs[category].map((tab, index) => (
                    <div key={tab.pos} className={[styles.text, pos === tab.pos ? styles.active : null].join(" ")}>
                        {index > 0 ? <Icon icon={arrow_right} /> : null}
                        {
                            pos > tab.pos ?
                                <div className={styles.done}>
                                    <Icon icon={ic_check} color="white" />
                                </div>
                                :
                                <div className={styles.icon}>
                                    {tab.pos}
                                </div>
                        }
                        {pos === tab.pos?
                        <Link className="link" to={tab.link}>
                            {tab.name}
                        </Link>:
                        <span className="link disabled">
                        {tab.name}
                      </span>}
                    </div>
                ))}
            </TopTitleBar>
        </div>

    )
}

export default Breadcrumb;